<template>
  <v-dialog
    v-model="value"
    persistent
    :max-width="width? width : '400'"
    content-class="loader-dialog"
  >
    <div class="d-flex flex-row">
      <v-progress-circular indeterminate color="amber" :size="70" :width="6" class="loader"></v-progress-circular>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "mloaderdialog",
  props: ["width", "value"],
  data() {
    return {
      // dialog: true
    };
  },
  mounted() {},
  watch: {
    // value: function(val) {
    //   this.dialog = val;
    // }
  },
  components: {},
  methods: {}
};
</script>
<style lang="scss" >
.loader-dialog {
  background-color: #ffffff00;
  box-shadow: none !important;
  overflow: inherit !important;
}
</style>
